/* =====================================================================
   Prime Review (mxpr) - 商品一覧カードに★評価+件数を差し込む
   各商品ページのHTMLから .star-ratings-css-top と .mxpr-rating-link を抜き取り、
   [data-mxpr-pending] のプレースホルダに反映する。
   sessionStorage に12hキャッシュ、同時接続3本まで。
===================================================================== */
(function () {
  'use strict';

  function init() {
    var placeholders = document.querySelectorAll('[data-mxpr-pending]');
    if (!placeholders.length) return;

    var CACHE_MS = 12 * 60 * 60 * 1000;
    var MAX_CONCURRENT = 3;

    function cacheGet(handle) {
      try {
        var raw = sessionStorage.getItem('mxpr-rating:' + handle);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || Date.now() - data.t > CACHE_MS) return null;
        return data;
      } catch (e) { return null; }
    }
    function cacheSet(handle, pct, count) {
      try {
        sessionStorage.setItem('mxpr-rating:' + handle, JSON.stringify({ t: Date.now(), pct: pct, count: count }));
      } catch (e) {}
    }

    function fetchRating(handle) {
      var cached = cacheGet(handle);
      if (cached) return Promise.resolve(cached);
      return fetch('/products/' + handle, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) return null;
          return res.text();
        })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var top = doc.querySelector('.star-ratings-css-top');
          var link = doc.querySelector('.mxpr-rating-link');
          if (!top) return null;
          var styleAttr = top.getAttribute('style') || '';
          var m = styleAttr.match(/width:\s*([\d.]+)%/);
          var pct = m ? parseFloat(m[1]) : 0;
          var countText = link ? (link.textContent || '').replace(/[^0-9]/g, '') : '';
          var count = countText ? parseInt(countText, 10) : 0;
          if (!count || pct <= 0) return null;
          cacheSet(handle, pct, count);
          return { pct: pct, count: count };
        })
        .catch(function () { return null; });
    }

    function applyRating(el, data) {
      var fill = el.querySelector('[data-mxpr-fill]') || el.querySelector('.mdl-tw__stars-fill');
      var countEl = el.querySelector('[data-mxpr-count]') || el.querySelector('.mdl-tw__rating-count');
      if (fill) fill.style.width = data.pct + '%';
      if (countEl) countEl.textContent = '(' + data.count + ')';
      el.removeAttribute('data-mxpr-pending');
      el.removeAttribute('hidden');
    }

    var queue = Array.prototype.slice.call(placeholders);
    var inflight = 0;
    function next() {
      while (inflight < MAX_CONCURRENT && queue.length) {
        var el = queue.shift();
        var handle = el.getAttribute('data-mxpr-handle');
        if (!handle) continue;
        inflight++;
        fetchRating(handle).then(function (data) {
          if (data) applyRating(this, data);
        }.bind(el)).then(function () {
          inflight--;
          next();
        }, function () {
          inflight--;
          next();
        });
      }
    }
    next();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
